import { Search } from '@berlitz/icons'
import ByLevelTab from '@layouts/GrammerTutor/ByLevel'
import ByTopicTab from '@layouts/GrammerTutor/ByTopic'

export const PRACTICE_HUB_VARIANTS = {
  Grammar: 'grammar',
  Conversation: 'conversation',
  Writing: 'writing',
}

export const PRACTICE_HUB_SUPPORTED_LANGUAGES = ['English', 'French', 'German', 'Spanish']

export const PRACTICE_HUB_ROUTES = {
  PRACTICE_HUB: '/practice-hub',
  GRAMMAR_TUTOR: '/practice-hub/grammar-tutor',
  GRAMMAR_LESSON: '/practice-hub/grammar-tutor/lesson',
  CONVERSATION_CHAT: '/practice-hub/conversation-partner-chat',
  CONVERSATION_VIDEO: '/practice-hub/conversation-partner-video',
  WRITING_TUTOR: '/practice-hub/writing-tutor',
}

export const PRACTICE_HUB_QUERY_KEYS = {
  LANG: 'lang',
  TAB: 'tab',
}

export const GRAMMAR_TUTOR_TABS = {
  BYLEVELTAB: 'by-level',
  BYTOPICTAB: 'by-topic',
  SEARCHTAB: 'search',
}
